// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"0f55228cb5385b95","5859":"22c317de96533df3","9771":"f81f4e3c829117c0"}[chunkId] + ".css";
};